import { render, staticRenderFns } from "./ListProductRegalar.vue?vue&type=template&id=21c2c6b0"
import script from "./ListProductRegalar.vue?vue&type=script&lang=js"
export * from "./ListProductRegalar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports